var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-chart-box"},[_c('cc-echarts',{attrs:{"id":_vm.id,"options":_vm.options}}),_vm._v(" "),_c('p',{staticClass:"fd-total"},[_vm._v(_vm._s(_vm.total)+"件")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }